export default __webpack_public_path__ + "static/media/boats.0e13da23.svg";